import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";

class Lists extends Component {
	constructor() {
		super();
		this.state = {
			dataKategori: [],
			arsip_cat_id: 0,
			pageCount: 0,
			currentPage: 0,
			isLoading: false,
			isModalShow: false
		};
	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	loadData() {
		this.setState({ isLoading: true });

		const params = qs.stringify({
			page: this.state.currentPage + 1
		});

		axios({
			method: "post",
			url: 'arsip/cat' + "?" + params
		})
			.then(response => {
				const result = response.data;
				if (result.success === true) {
					this.setState({
						dataKategori: result.data.data,
						pageCount: result.data.last_page,
						isLoading: false
					});
				} else {
					Alert.error(result.message);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-block">
						<NavLink
							to={`${this.props.match.url}/add`}
							className="btn btn-primary"
						>
							Tambah Kategori
						</NavLink>
					</div>
				</div>
				<div className="card">
					<div className="card-header">Data Kategori</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : this.state.dataKategori.length === 0 ? (
							"Data Kosong..."
						) : (
							<div>
								<table className="table table-striped table-bordered animated fadeIn">
									<thead>
										<tr>
											<th>Nama Kategori</th>
											<th width={100}>Status</th>
											<th width={100}>Opsi</th>
										</tr>
									</thead>
									<tbody>
										{this.state.dataKategori.map(item => {
											return (
												<tr key={item.arsip_cat_id}>
													<td>{item.arsip_cat_name}</td>
													<td>
														{
															item.arsip_cat_status === '1' ? (
																<span className="badge badge-primary">Active</span>
															):(
																<span className="badge badge-danger">Non-Active</span>
															)
														}
													</td>
													<td>
														<NavLink
															to={`${this.props.match.url}/edit/${
																item.arsip_cat_id
															}`}
															className="btn btn-secondary btn-sm"
														>
															Edit
														</NavLink>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>

								<Paging
									handlePageClick={this.handlePageClick.bind(this)}
									pageCount={this.state.pageCount}
									currentPage={this.state.currentPage}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Arsip/Category/Lists.js